var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependentLivingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9819 49.5H4.98193M4.98193 24.75L23.2654 10.125C24.4623 9.16761 25.9493 8.64602 27.4819 8.64602C29.0146 8.64602 30.5016 9.16761 31.6984 10.125L49.9819 24.75M35.3569 12.375V7.875C35.3569 7.57663 35.4755 7.29048 35.6864 7.07951C35.8974 6.86853 36.1836 6.75 36.4819 6.75H42.1069C42.4053 6.75 42.6915 6.86853 42.9024 7.07951C43.1134 7.29048 43.2319 7.57663 43.2319 7.875V19.125M9.48193 49.5V21.375M45.4819 49.5V21.375",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2319 49.5V38.25C34.2319 35.0685 34.2319 33.4777 33.2419 32.49C32.2564 31.5 30.6657 31.5 27.4819 31.5C24.3004 31.5 22.7097 31.5 21.7219 32.49C20.7319 33.4755 20.7319 35.0663 20.7319 38.25V49.5M31.9819 21.375C31.9819 22.5685 31.5078 23.7131 30.6639 24.557C29.82 25.4009 28.6754 25.875 27.4819 25.875C26.2885 25.875 25.1439 25.4009 24.3 24.557C23.456 23.7131 22.9819 22.5685 22.9819 21.375C22.9819 20.1815 23.456 19.0369 24.3 18.193C25.1439 17.3491 26.2885 16.875 27.4819 16.875C28.6754 16.875 29.82 17.3491 30.6639 18.193C31.5078 19.0369 31.9819 20.1815 31.9819 21.375Z",
    stroke: "#278DEC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependentLivingIcon);
export default __webpack_public_path__ + "static/media/independentLivingIcon.0b71ebbe667fb1a2836bf61f87160414.svg";
export { ForwardRef as ReactComponent };